export const mutations = {
  WALLET_LOADING(state, value) { state.loading = value; },
  WALLET_ERROR(state, value) { state.error = value; },
  WALLET_ACCOUNT(state, value) { state.account = value; },
  WALLET_TRANSACTIONS(state, value) {
    state.transactions = value.data || [];
    state.pagination = value.pagination || state.pagination;
  }
};
